import Client from '../client';
import {flattenObject} from '../helpers';
import {GetAllProvincesRequestBuilder} from '../provinces/provinces';
import {GetAllCitiesRequestBuilder} from '../cities/cities';
import {GetAllAgenciesRequestBuilder} from '../supervisors/supervisors';
import {GetPartnerCategoriesRequestBuilder} from '../products/products';
import { InitRequestBuilder } from '../action-services/action-services';

const token = localStorage.getItem('token') || '';

class CommonRepository {
  getProvinces = async (actions: any) => {
    const makeProvincesRequest = new GetAllProvincesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 50}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeProvincesRequest);
    return response;
  };
  getCities = async (actions: any) => {
    const makeCitiesRequest = new GetAllCitiesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 1000}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeCitiesRequest);
    return response;
  };
  getPartnerCategories = async (actions: any) => {
    const makeRequest = new GetPartnerCategoriesRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getSupervisors = async (actions: any) => {
    const makeRequest = new GetAllAgenciesRequestBuilder()
      .params(flattenObject({...actions.payload, size: 100}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  ticketInit = async (actions: any) => {
    const makeRequest = new InitRequestBuilder().build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  }
}

export default new CommonRepository();
